import { CheckCircle2, Circle, XCircle } from 'lucide-react';

export const CourseSidebar = ({ slides, currentSlide, progress, onGoToSlide }) => (
  <>
    {/* Desktop sidebar */}
    <div className="hidden lg:block bg-white rounded-xl border border-slate-200 p-3 h-fit sticky top-36" data-testid="slide-sidebar">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider px-2 mb-2">Sommaire</p>
      <nav className="space-y-0.5 max-h-[60vh] overflow-y-auto">
        {slides.map((slide, i) => {
          const isCompleted = progress?.completed_slides?.includes(slide.id);
          const isCurrent = i === currentSlide;
          const isQuizSlide = slide.type === 'quiz';
          const slideQuizScore = progress?.quiz_scores?.[slide.id];
          const quizPassedStatus = slideQuizScore?.passed;
          return (
            <button
              key={slide.id}
              onClick={() => onGoToSlide(i)}
              className={`w-full flex items-center gap-2 px-2.5 py-2 rounded-lg text-xs font-medium transition-all text-left ${
                isCurrent ? 'bg-teal-50 text-teal-700 ring-1 ring-teal-200' : 'text-slate-600 hover:bg-slate-50'
              }`}
              data-testid={`slide-nav-${i}`}
            >
              {isQuizSlide && slideQuizScore ? (
                quizPassedStatus
                  ? <CheckCircle2 className="w-3.5 h-3.5 text-green-500 shrink-0" />
                  : <XCircle className="w-3.5 h-3.5 text-red-500 shrink-0" />
              ) : isCompleted ? (
                <CheckCircle2 className="w-3.5 h-3.5 text-teal-500 shrink-0" />
              ) : (
                <Circle className="w-3.5 h-3.5 text-slate-300 shrink-0" />
              )}
              <span className="truncate">{slide.title}</span>
              {isQuizSlide && slideQuizScore && (
                <span className={`ml-auto text-[10px] font-bold shrink-0 ${quizPassedStatus ? 'text-green-600' : 'text-red-500'}`}>
                  {slideQuizScore.score}%
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>

    {/* Mobile nav (rendered separately in parent layout) */}
  </>
);

export const CourseMobileNav = ({ slides, currentSlide, progress, onGoToSlide }) => (
  <div className="lg:hidden bg-white rounded-xl border border-slate-200 p-3">
    <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider px-2 mb-2">Slides</p>
    <div className="flex flex-wrap gap-1">
      {slides.map((slide, i) => {
        const isCompleted = progress?.completed_slides?.includes(slide.id);
        return (
          <button
            key={slide.id}
            onClick={() => onGoToSlide(i)}
            className={`w-8 h-8 rounded-lg text-xs font-bold flex items-center justify-center transition-all ${
              i === currentSlide ? 'bg-teal-600 text-white' :
              isCompleted ? 'bg-teal-100 text-teal-700' :
              'bg-slate-100 text-slate-500 hover:bg-slate-200'
            }`}
          >
            {i + 1}
          </button>
        );
      })}
    </div>
  </div>
);
